import React, { FunctionComponent } from 'react';

import { useSelector } from 'react-redux';

import { useActions } from '../../../../../hooks';
import { SubmodalId } from '../../../constants';
import { closeSettingsSubmodalAction, selectSettingsSubmodalId } from '../../../slice';
import { PermissionsExtendedResetModal } from './permissions-extended/reset';
import { PermissionsExtendedReturnToDefaultModal } from './permissions-extended/return-to-default';
import { ConfirmSubmodalProps } from './types';

const COMPONENT_BY_SUBMODAL_ID = {
    [SubmodalId.PERMISSIONS_EXTENDED_RESET]: PermissionsExtendedResetModal,
    [SubmodalId.PERMISSIONS_EXTENDED_RETURN_TO_DEFAULT]: PermissionsExtendedReturnToDefaultModal,
} as const;

export type SubmodalsManagerProps = Pick<ConfirmSubmodalProps, 'zIndex'>;

export const SubmodalsManager: FunctionComponent<SubmodalsManagerProps> = (props) => {
    const { closeSubmodal } = useActions({
        closeSubmodal: closeSettingsSubmodalAction,
    });

    const submodalId = useSelector(selectSettingsSubmodalId);

    if (!submodalId) {
        return null;
    }

    const onConfirm = () => closeSubmodal({ isConfirmed: true });
    const onClose = () => closeSubmodal({ isConfirmed: false });

    const Submodal = COMPONENT_BY_SUBMODAL_ID[submodalId];

    return <Submodal {...props} onConfirm={onConfirm} onClose={onClose} onCancel={onClose} />;
};
